<div class="header">
  <div class="header-navigation">
    <button mat-icon-button (click)="clickToggleDrawer()" *ngIf="!forbidden">
      <mat-icon>menu</mat-icon>
    </button>
    <a [routerLink]="getLocaleUrl()">
      <div class="header-brand">
        <div class="brand-logo">
          <img
            src="../../../assets/img/viessmann-white.svg"
            alt="Viessmann Logo"
          />
        </div>
        <div class="brand-title">
          {{ environment.app.title }}
        </div>
      </div></a
    >
  </div>
  <app-search-bar *ngIf="!forbidden"></app-search-bar>
  <div class="header-toolbar">
    <vih-login></vih-login>
  </div>
</div>
